
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers",
      function () {
        return require("private-next-pages/rollers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers"])
      });
    }
  